import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Config } from '@app/config';
import { DateHelper } from '@app/utilities/helpers';

import { FetchApi } from '@app/services/api';
import { AuthCustomerService, AuthStaffService } from '@app/services/auth';
import { DialogService } from '@app/services/dialog';

import { VersionNumber } from './models';

import { default as Manifest } from '../../../manifest.json';

@Injectable()
export class VersionCheckService {
    public outOfDate$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public criticalUpdate$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    private currentVersion: VersionNumber;
    private frequencyInHours = 1000 * 60 * 10;
    private frequencyOutHours = 1000 * 60 * 60;

    private businessStart = '09:00:00';
    private businessEnd = '17:00:00';
    private currentlyInHours: boolean = false;

    private interval;

    constructor(
        protected config: Config,
        protected fetchApi: FetchApi,
        protected authStaffService: AuthStaffService,
        protected authCustomerService: AuthCustomerService,
        protected dialogService: DialogService
    ) {
        if (Manifest && Manifest.version) {
            this.currentVersion = new VersionNumber(Manifest.version);
        }
    }

    public initVersionCheck(url) {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }

        let frequency;
        if (this.isInHours()) {
            frequency = this.frequencyInHours;
            this.currentlyInHours = true;
        } else {
            frequency = this.frequencyOutHours;
            this.currentlyInHours = false;
        }

        this.checkVersion(url);

        this.interval = setInterval(() => {
            this.checkVersion(url);
        }, frequency);
    }

    private isInHours() {
        const now = DateHelper.moment();

        return now.isBetween(`${now.format('YYYY-MM-DD')} ${this.businessStart}`, `${now.format('YYYY-MM-DD')} ${this.businessEnd}`);
    }

    private checkVersion(url) {
        if ((this.isInHours() && !this.currentlyInHours) || (!this.isInHours() && this.currentlyInHours)) {
            this.initVersionCheck(url);

            return;
        }

        this.getVersion(url)
            .then((response) => {
                if (response && !response.version) {
                    return;
                }

                const version = new VersionNumber(response.version);
                if (!this.currentVersion) {
                    this.currentVersion = version;

                    return;
                }

                if (this.currentVersion.major < version.major || this.currentVersion.minor < version.minor) {
                    this.outOfDate$.next(true);
                    this.criticalUpdate$.next(true);
                    // this.dialogService.html(
                    //     'Version Update',
                    //     'A new version of the app is available.<br /><br />' +
                    //     'Please reload the page.<br /><br />' +
                    //     'If this message keeps appearing please try:<br />' +
                    //     '<strong>CTRL + SHIFT + R</strong> otherwise clear your browser cache.',
                    //     {
                    //         disableClose: true,
                    //         minHeight: 'auto',
                    //         data: {
                    //             buttons: null
                    //         }
                    //     }
                    // );
                } else if (this.currentVersion.patch < version.patch) {
                    this.outOfDate$.next(true);
                } else {
                    this.outOfDate$.next(false);
                    this.criticalUpdate$.next(false);
                }
            })
            .catch((error) => console.error(error));
    }

    private getVersion(url): Promise<any> {
        return new Promise((resolve, reject) => {
            this.fetchApi.json(`${url}./manifest.json?t=${DateHelper.timestamp()}`)
                .then((response) => {
                    if (response) {
                        resolve(response);
                    } else {
                        reject();
                    }
                })
                .catch((error) => reject(error));
        });
    }
}
